import { FormControlLabel, Row } from "@commonlibs";
import clsx from "clsx";
import { spacing } from "ui/config/theme/spacing/spacing";
import DeleteButton from "../DeleteButton/DeleteButton";
import UploadButton from "../UploadButton/UploadButton";
import { UploadButtonProps } from "../UploadButton/UploadButton.types";
import { UploadedFile } from "../UploadInput/UploadInput.types";
import { FileUploadControlsRoot } from "./FileUploadControls.styles";
import { FileUploadControlsProps } from "./FileUploadControls.types";

const gap = spacing["6"];
const rowGap = spacing["3"];

function FileUploadControls<Multiple extends boolean = false>({
    //UploadProps
    fileTypes,
    readonly,
    disabled,
    multiple,
    onError,
    onFileUploaded,
    onUploadEnd,
    onUploadStart,
    upload,
    onSuccess,
    isLoading,
    //ButtonsProps
    showDelete = true,
    className,
    style,
    changeButtonProps,
    uploadButtonProps,
    buttonSize = "lg",
    //FormControlProps
    LabelProps = {},
    Label = FormControlLabel,
    defaultValue,
    ...rest
}: FileUploadControlsProps<Multiple>) {
    const uploadProps: Partial<UploadButtonProps> = {
        fileTypes,
        readonly,
        disabled,
        multiple,
        onError,
        onFileUploaded,
        onUploadStart,
        onSuccess,
        isLoading,
    };
    return (
        <FileUploadControlsRoot
            Label={[Label, LabelProps]}
            defaultValue={defaultValue}
            readonly={readonly}
            disabled={disabled}
            className={clsx("file-upload-controls")}
            css={{ justifyContent: "center" }}
            style={style}
            {...rest}
        >
            {(value, setValue) => {
                function handleFileChange(fileUri: UploadedFile | undefined) {
                    setValue(fileUri as (Multiple extends true ? string[] : string) | undefined);
                    onUploadEnd?.(fileUri);
                }

                return (
                    <Row
                        justifyContent="center"
                        alignItems="center"
                        className={clsx("file-upload-controls", className)}
                        wrap
                        wrapGap={rowGap}
                        gap={gap}
                    >
                        {showDelete && value && (
                            <DeleteButton
                                disabled={disabled || readonly}
                                size={buttonSize}
                                onClick={() => {
                                    setValue(undefined); // skipcq: JS-W1042
                                }}
                            />
                        )}
                        <UploadButton
                            size={buttonSize}
                            {...uploadProps}
                            upload={upload}
                            display={value ? "change" : "upload"}
                            onUploadEnd={handleFileChange}
                            uploadButtonProps={uploadButtonProps}
                            changeButtonProps={changeButtonProps}
                        />
                    </Row>
                );
            }}
        </FileUploadControlsRoot>
    );
}

export default FileUploadControls;
